/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect } from 'react'
import RpeCalculator from '../tools/RpeCalculator.jsx'
import BmiCalculator from '../tools/BmiCalculator.jsx'
import SiteShell from './SiteShell.jsx'
import { APP_TOOLS_URL } from '../data/tools.js'

export function RpeToolPage() {
  return (
    <SiteShell variant="tool">
      <RpeCalculator />
    </SiteShell>
  )
}

export function BmiToolPage() {
  return (
    <SiteShell variant="tool">
      <BmiCalculator />
    </SiteShell>
  )
}

export function ToolRedirect({ slug }) {
  const href = APP_TOOLS_URL + slug
  useEffect(() => {
    window.location.replace(href)
  }, [href])
  return (
    <p dir="rtl" style={{ padding: 24, textAlign: 'center' }}>
      <a href={href}>ورود به ابزار در اپلیکیشن سکویا</a>
    </p>
  )
}
